import React, { useState } from 'react';
import { LISTING_TYPE } from '../platformUtils';

import useSampleProperties from './useSampleProperties';

function useTrendingProperties() {
    const [trendingProperties, setTrendingProperties] = useState(useSampleProperties(4));
    
    // TODO: get trending properties from Moralis or custom backend

    return useTrendingProperties;
}

export default useTrendingProperties;